var _path, _path2, _path3, _g, _path4, _g2, _path5, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.76094 15.6172C9.56894 15.6172 9.37694 15.5442 9.23094 15.3972C8.49294 14.6602 8.08594 13.6802 8.08594 12.6382C8.08594 10.4782 9.84194 8.72119 11.9999 8.72119C13.0379 8.72119 14.0459 9.14019 14.7649 9.87119C15.0549 10.1672 15.0519 10.6412 14.7559 10.9312C14.4609 11.2232 13.9869 11.2182 13.6959 10.9242C13.2569 10.4772 12.6389 10.2212 11.9999 10.2212C10.6689 10.2212 9.58594 11.3052 9.58594 12.6382C9.58594 13.2792 9.83694 13.8832 10.2909 14.3372C10.5839 14.6302 10.5839 15.1042 10.2919 15.3972C10.1449 15.5442 9.95294 15.6172 9.76094 15.6172Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5676 16.4913C12.2126 16.4913 11.8966 16.2373 11.8306 15.8753C11.7566 15.4683 12.0266 15.0773 12.4346 15.0033C13.4146 14.8253 14.1906 14.0473 14.3666 13.0663C14.4406 12.6593 14.8306 12.3913 15.2376 12.4613C15.6456 12.5343 15.9166 12.9243 15.8436 13.3323C15.5566 14.9253 14.2946 16.1893 12.7026 16.4793C12.6576 16.4873 12.6116 16.4913 12.5676 16.4913Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_67_1649",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 17,
    height: 15
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4.62451H18.0862V18.7226H2V4.62451Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_67_1649)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6545 18.7226C6.4925 18.7226 6.3295 18.6696 6.1915 18.5626C4.5005 17.2346 3.0715 15.2876 2.0615 12.9336C1.9795 12.7436 1.9795 12.5296 2.0615 12.3406C3.0825 9.97664 4.5205 8.01964 6.2205 6.68264C9.6865 3.93964 14.3005 3.93064 17.8015 6.70264C18.1265 6.95964 18.1815 7.43164 17.9245 7.75664C17.6665 8.07964 17.1965 8.13664 16.8705 7.87864C13.9045 5.53064 10.0835 5.53864 7.1495 7.86064C5.7135 8.99064 4.4805 10.6366 3.5705 12.6386C4.4715 14.6286 5.6935 16.2646 7.1185 17.3826C7.4445 17.6386 7.5005 18.1106 7.2445 18.4356C7.0965 18.6236 6.8765 18.7226 6.6545 18.7226Z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_67_1649",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 14,
    height: 13
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.71729 8.74121H21.9998V20.6894H8.71729V8.74121Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_67_1649)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 20.6894C11.0629 20.6894 10.1309 20.5374 9.23092 20.2384C8.83792 20.1074 8.62492 19.6824 8.75592 19.2894C8.88692 18.8954 9.30992 18.6864 9.70492 18.8144C10.4519 19.0634 11.2239 19.1894 11.9999 19.1894C15.4279 19.1894 18.5609 16.7474 20.4299 12.6364C19.9739 11.6374 19.4429 10.7324 18.8489 9.94242C18.5999 9.61142 18.6659 9.14042 18.9969 8.89142C19.3269 8.64242 19.7979 8.71042 20.0469 9.04042C20.7709 10.0014 21.4069 11.1124 21.9379 12.3384C22.0209 12.5284 22.0209 12.7444 21.9379 12.9334C19.8419 17.7904 16.1269 20.6894 11.9999 20.6894Z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_67_1649",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 4,
    width: 18,
    height: 18
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.36377 4.00049H20.6373V21.2735H3.36377V4.00049Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_67_1649)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.11352 21.2735C3.92152 21.2735 3.72952 21.2005 3.58352 21.0535C3.29052 20.7605 3.29052 20.2865 3.58352 19.9935L19.3575 4.21951C19.6505 3.92651 20.1245 3.92651 20.4175 4.21951C20.7105 4.51251 20.7105 4.98751 20.4175 5.28051L4.64352 21.0535C4.49752 21.2005 4.30552 21.2735 4.11352 21.2735Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/Hide.b63c69ce058138968a41591a9d4bc7b5.svg";
export { ForwardRef as ReactComponent };